import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface ComplexTooltipContentProps {
  className?: string;
  maxWidth: number;
  title: ReactNode;
  body: ReactNode;
  imageUrl?: string;
  imageDescription?: string;
  imageRounded?: boolean;
}

/*
 * Style.
 */

interface TooltipContentStyleProps {
  $maxWidth: number;
}
export const StyledTooltipContentDiv = styled.div<TooltipContentStyleProps>`
  max-width: ${(p) => `${p.$maxWidth}px`};
  padding: 11px 10px;
`;

const StyledTooltipHeaderDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
  line-height: 18px;
  padding: 0px 0px 8px 0px;
`;

export const StyledTooltipBodyDiv = styled.div`
  line-height: 1.5;
  font-weight: ${fontWeights.medium};
`;

interface StyledTooltipImageProps {
  $rounded: boolean;
}

const StyledTooltipImage = styled.img<StyledTooltipImageProps>`
  height: auto;
  width: 100%;

  border-radius: ${(p) => (p.$rounded ? 8 : 0)}px;
  overflow: hidden;
`;

/*
 * Component.
 */

export const ComplexTooltipContent: FC<ComplexTooltipContentProps> = (props) => (
  <StyledTooltipContentDiv $maxWidth={props.maxWidth} className={props.className}>
    <StyledTooltipHeaderDiv>{props.title}</StyledTooltipHeaderDiv>
    <StyledTooltipBodyDiv>{props.body}</StyledTooltipBodyDiv>
    {maybeRenderTooltipImage(props)}
  </StyledTooltipContentDiv>
);

function maybeRenderTooltipImage(props: ComplexTooltipContentProps) {
  if (!props.imageUrl || !props.imageDescription) {
    return null;
  }

  return (
    <StyledTooltipImage
      src={props.imageUrl}
      alt={props.imageDescription}
      $rounded={Boolean(props.imageRounded)}
    />
  );
}
